/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'date-left': {
    width: 23.406,
    height: 16,
    viewBox: '0 0 1498 1024',
    data: '<path pid="0" d="M1299.269 1024H198.194A196.62 196.62 0 011.573 827.38a119.545 119.545 0 0118.09-62.92l379.084-607.164A197.407 197.407 0 01591.435 0a117.972 117.972 0 0133.818 230.44 92.018 92.018 0 01-12.583 28.313l-329.536 527.73h983.103a117.972 117.972 0 01229.652 39.323A196.62 196.62 0 011299.27 1024z" _fill="#C6DCEE"/>'
  }
})
